import { useState, useEffect } from 'react'

import { type PropertyValue } from 'api/clients/PropertyClient'
import { getRandomColor } from 'common/PropertyForm/ColorInput'

export const useUniqueNewColor = (propertyValues: PropertyValue[]) => {
  const [newColor, setNewColor] = useState<string | undefined>()
  const [newColorAttempts, setNewColorAttempts] = useState(0)

  const resetColor = () => {
    setNewColor(undefined)
    setNewColorAttempts(0)
  }

  useEffect(() => {
    if (newColor || !propertyValues) return

    if (newColorAttempts > 20) {
      setNewColor(getRandomColor())
    }

    let possibleNewColor: string | undefined = getRandomColor()

    propertyValues.forEach((propertyValue) => {
      if (propertyValue?.meta?.color === possibleNewColor) {
        possibleNewColor = undefined
      }
    })

    if (possibleNewColor) {
      setNewColor(possibleNewColor)
      return
    }

    setNewColorAttempts(newColorAttempts + 1)
  }, [newColor, propertyValues, newColorAttempts])

  return { newColor, resetColor }
}
